import React from 'react';
import type { Preview } from '@storybook/react';
import { Setup } from '../.storybook-shared/decorators';

const preview: Preview = {
  decorators: [(Story) => <Setup Story={Story} />],
  parameters: {
    controls: {
      matchers: {
        color: /(background|color)$/i,
        date: /Date$/,
      },
    },
  },
};

export default preview;
